import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Flag key. If '1' (or missing for backward compat) => persistent (localStorage).
// If '0' => session-only (sessionStorage): logs out when browser is closed.
const REMEMBER_KEY = 'sp_remember_me';

export function setRememberMe(remember) {
  try {
    localStorage.setItem(REMEMBER_KEY, remember ? '1' : '0');
  } catch (err) {
    // localStorage may be unavailable (private browsing). Non-critical.
    console.warn('setRememberMe failed:', err);
  }
}

export function getRememberMe() {
  try {
    // Default to true (persistent) on first visit
    const v = localStorage.getItem(REMEMBER_KEY);
    return v === null ? true : v === '1';
  } catch (err) {
    console.warn('getRememberMe failed:', err);
    return true;
  }
}

// Custom storage: routes auth tokens to localStorage when "Remember me" is on,
// otherwise to sessionStorage (cleared when browser closes).
const hybridStorage = {
  getItem: (key) => {
    try {
      return sessionStorage.getItem(key) ?? localStorage.getItem(key);
    } catch (err) {
      console.warn('hybridStorage.getItem failed:', err);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      if (getRememberMe()) {
        localStorage.setItem(key, value);
        sessionStorage.removeItem(key);
      } else {
        sessionStorage.setItem(key, value);
        localStorage.removeItem(key);
      }
    } catch (err) {
      console.warn('hybridStorage.setItem failed:', err);
    }
  },
  removeItem: (key) => {
    try {
      sessionStorage.removeItem(key);
      localStorage.removeItem(key);
    } catch (err) {
      console.warn('hybridStorage.removeItem failed:', err);
    }
  },
};

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: hybridStorage,
  },
});

export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);
